import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { send2FaCodeToNumber } from '@api/userProfile';

import { ICheckPhoneNumberDTO } from '@interfaces/user/dto/userProfileDTO';

import { HISTORY_2FA, SEND_CODE_TO_NUMBER } from '@constants/queryKeys';

export const useMutateSendCodeToNumber = () => {
	const queryClient = useQueryClient();

	const {
		mutateAsync: sendCodeToNumber,
		isLoading: isLoadingSendCodeToNumber,
	} = useMutation<ICheckPhoneNumberDTO>({
		mutationKey: [SEND_CODE_TO_NUMBER],
		mutationFn: send2FaCodeToNumber,
		onSuccess: () => {
			return queryClient.invalidateQueries([HISTORY_2FA]);
		},
	});

	return {
		sendCodeToNumber,
		isLoadingSendCodeToNumber,
	};
};
